import React from 'react'
import { Points } from './components/points';
import { Split } from './components/split';
import { ContactForm } from './components/contactform';

export class Seeking extends React.Component {

    render() {
        return (
            <Split>
                <Points>
                    {{ "heading" : "What we are looking for:",
                       "points"  : [
                            {
                                "header"      : "Strategic Investors",
                                "icon"        : "💰",
                                "description" : "Join Norway's next AI adventure. We're looking for financial backers who want to be part of building a globally competitive AI platform from Oslo. This is an opportunity to invest in proven technology with a clear path to commercialization."
                            },
                            {
                                "header"      : "Chief Executive Officer",
                                "icon"        : "🎯",
                                "description" : "Visionary leader to drive overall strategy, partnerships, and company growth while I focus on technology as CTO."
                            },
                            {
                                "header"      : "Legal & Compliance",
                                "icon"        : "⚖️",
                                "description" : "Navigate Norwegian startup regulations, establish proper legal entity, handle compliance and intellectual property protection."
                            },
                            {
                                "header"      : "Sales & Marketing",
                                "icon"        : "🚀",
                                "description" : "Experienced professionals to develop go-to-market strategy, build partnerships, and establish our brand in the AI market."
                            }
                    ]}}
                </Points>
                <div className="contact-container">
                    <h2>Let’s talk!</h2>
                    <p>Whether you're an investor, experienced manager, technical expert, or simply curious about joining an ambitious Oslo-based AI startup, we want to hear from you. You can either send mail to info@tigercity.ai or use the form below.</p>
                    <ContactForm/>
                </div>
            </Split>
        );
    }
}

